<template>
  <div class="offer-feature-section" id="processes" v-scroll-animate>
    <div class="main-container">
      <feature3
        v-for="(feature, index) in fields.field_one.value.boxes"
        ref="features"
        :key="feature.name"
        :feature="feature"
        @open="onOpen(index)"
      />
    </div>
  </div>
</template>

<script>
import Feature3 from "/seu-frontend/components/section-fields/Feature3";

export default {
  name: "OfferFeatureSection",
  components: {Feature3},
  props: {
    fields: {
      type: Object
    }
  },
  methods: {
    onOpen(index) {
      this.$refs.features.forEach((f, i) => {
        if(i !== index) {
          f.closeMore();
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import "OfferFeatureSection.scss";
</style>
